import { memo } from 'react';
import { Typography } from '../../../../../components/typography/typography';
import classNames from 'classnames';
import styles from './product-item.module.css';
import { displayMoneyFormat } from '../../../../../util/util';
import { Currency } from 'dinero.js';
import { ProductItemState } from '../../hooks/use-product-item-data';

interface ProductItemTotalProps extends Pick<ProductItemState, 'total' | 'isTaxInclusive' | 'totalTaxPercentage'> {
  currency: string | Currency;
}

export const ProductItemTotal = memo(
  ({ total, isTaxInclusive, totalTaxPercentage, currency }: ProductItemTotalProps) => {
    const totalWithTax = isTaxInclusive && totalTaxPercentage ? total * (1 + totalTaxPercentage / 100) : total;
    return (
      <Typography
        type="text-sm"
        weight="regular"
        className={classNames(styles.fieldContentText)}
        dataCy="product-item-total"
      >
        {displayMoneyFormat(totalWithTax, currency)}
      </Typography>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.total === nextProps.total &&
      prevProps.currency === nextProps.currency &&
      prevProps.isTaxInclusive === nextProps.isTaxInclusive &&
      prevProps.totalTaxPercentage === nextProps.totalTaxPercentage
    );
  },
);

ProductItemTotal.displayName = 'ProductItemTotal';
